/**
 * @generated SignedSource<<ba266c6b6652c9156648d781b8aee7aa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitDetailsModal_paymentAddresses$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsContent_paymentAddresses">;
  readonly " $fragmentType": "SplitDetailsModal_paymentAddresses";
};
export type SplitDetailsModal_paymentAddresses$key = {
  readonly " $data"?: SplitDetailsModal_paymentAddresses$data;
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsModal_paymentAddresses">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SplitDetailsModal_paymentAddresses",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SplitDetailsContent_paymentAddresses"
    }
  ],
  "type": "PaymentAddresses",
  "abstractKey": null
};

(node as any).hash = "d9d535c7cd1387b20c7e34c116f88c3e";

export default node;
